import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { CSSTransitionGroup } from 'react-transition-group';
import * as zenscroll from 'zenscroll';
import * as classNames from 'classnames';

// Styles
const s = require('./Modal.css');
const closeIcon = require('./../../assets/cross-orange-sign.svg');

// Props
interface IModalProps {
    show?: boolean;
    title?: string;
    closeLabel?: string;
    hideCloseButton?: boolean;
    narrow?: boolean;
    onClose?: () => void;
    onDisabledClose?: () => void;
    disableClose?: boolean;
    onModalContainerClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

@observer
export class Modal extends React.Component<IModalProps, {}> {
    static get defaultProps(): IModalProps {
        return {
            show: false,
            title: null,
            closeLabel: 'Close',
            hideCloseButton: false,
            narrow: false,
            onClose: null,
            disableClose: false,
            onModalContainerClick: null
        };
    }

    constructor(props: IModalProps) {
        super(props);

        if (this.props.show) {
            setTimeout(() => {
                this.showModal();
            }, 256);
        }
    }

    private enterAnimationTime: number = 700;
    private leaveAnimationTime: number = 500;

    @observable private show: boolean = false;

    public componentWillUpdate(nextProps: IModalProps) {
        if (this.props.show !== nextProps.show) {
            setTimeout(() => {
                if (nextProps.show) {
                    this.showModal();
                } else {
                    this.hideModal();
                }
            }, 128);
        }
    }

    private wrapper: HTMLDivElement = null;
    private referenceWrapper = (ref: HTMLDivElement) => (this.wrapper = ref);

    public render() {
        return (
            <CSSTransitionGroup
                component="div"
                transitionName="modal"
                transitionAppear={true}
                transitionAppearTimeout={this.enterAnimationTime}
                transitionEnter={true}
                transitionEnterTimeout={this.enterAnimationTime}
                transitionLeave={true}
                transitionLeaveTimeout={this.leaveAnimationTime}
            >
                {this.show && (
                    <div key="modal-background" className={s.background} onClick={this.handleBackgroundClick}>
                        <div className={s.wrapper} ref={this.referenceWrapper}>
                            <div
                              className={classNames(s.container, {
                                narrow: this.props.narrow
                              })}
                              onClick={this.handleContainerClick}
                            >
                                <div className={s.titleBar}>
                                    <div className={s.titleBarHeadline}>{this.props.title && <h5>{this.props.title}</h5>}</div>

                                    <div className={s.titleBarIcons}>
                                        {this.props.hideCloseButton === false && (
                                            <button onClick={this.handleCloseButtonClick}>
                                                <span>{this.props.closeLabel}</span>
                                                <img src={closeIcon} alt="" />
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {typeof this.props.children !== 'undefined' &&
                                    this.props.children && <div className={s.content}>{this.props.children}</div>}
                            </div>
                        </div>
                    </div>
                )}
            </CSSTransitionGroup>
        );
    }

    private showModal = () => {
        this.show = true;
        document.documentElement.style.overflow = 'hidden';
    };

    private hideModal = () => {
        this.show = false;

        setTimeout(() => {
            document.documentElement.style.overflow = null;
        }, this.leaveAnimationTime);

        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    private attemptToHideModal = () => {
        if (this.props.hideCloseButton === false && this.props.disableClose === false) {
            this.hideModal();
        } else {
            if (this.props.onDisabledClose) {
                this.props.onDisabledClose();
            }
        }
    };

    private handleBackgroundClick = (e: React.MouseEvent<HTMLDivElement>) => {
        this.attemptToHideModal();
    };

    private handleContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();

        if (this.props.onModalContainerClick) {
            this.props.onModalContainerClick(e);
        }
    };

    private handleCloseButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        this.attemptToHideModal();
    };

    public scrollToTop = () => {
        if (this.wrapper) {
            const scroller = zenscroll.createScroller(this.wrapper, 500, 0);
            scroller.toY(0);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/popup/Modal.tsx